import styled from 'styled-components';

export type ProductsListType = {
  layout: string;
};

const pickLayoutType = (layout: string) => {
  switch (layout) {
    case 'grid':
      return '1fr 1fr 1fr 1fr';
    case 'grid2':
      return '1fr 1fr 1fr 1fr 1fr';
    default:
      return '1fr 1fr 1fr';
  }
};

const Wrapper = styled.div<ProductsListType>`
  display: grid;
  grid-template-columns: ${({ layout }) => pickLayoutType(layout)};
  gap: 6.5rem 2rem;

  padding: 3rem 1.5rem;
`;

const EmptyMessage = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6rem 0;
`;

export { EmptyMessage, Wrapper };
